import { useTranslations } from '@/hooks';
import { AttachmentsTabView } from '@/components/common';
import { LoadingOverlay } from '@/components/feedback';
import { ATTACHMENT_TARGETS } from '@/lib/api/attachmentsApi';
import { EMPTY_LIST } from '@/lib/utils';
import { useGetDeclarationAttachmentsQuery } from '../api/declarationsApi';

/**
 * Props:
 *   module         the active module route segment
 *   declarationId  the declaration whose attachments the tab reads
 *   referenceId    the declaration's business id, for the modal title
 */
export const DeclarationAttachmentsTabView = ({ module, declarationId, referenceId }) => {
  const t = useTranslations();

  const { data: attachments = EMPTY_LIST, isLoading } = useGetDeclarationAttachmentsQuery({
    id: declarationId,
  });

  if (isLoading) {
    return <LoadingOverlay label={t('COMMON_LOADING')} />;
  }

  return (
    <AttachmentsTabView
      attachments={attachments}
      target={ATTACHMENT_TARGETS.declaration}
      module={module}
      entityId={declarationId}
      modalTitle={t('DECLARATIONS_ADD_ATTACHMENT_MODAL_TITLE', { referenceId })}
      addLabel={t('ACTION_ADD_ATTACHMENT')}
    />
  );
};
